import { Alert, Autocomplete, Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router";

const EditReportPage = (props) => {

    const { id } = useParams();
    const navigate = useNavigate();
 
    const [product, setProduct] = useState("");
    const [searchedProducts, setSearchedProducts] = useState([]);
    const [duration, setDuration] = useState(0);
    const [temperature, setTemperature] = useState(0);
    const [crispyness, setCrispyness] = useState("");
    const [crispynessValues, setCrispynessValues] = useState([]);
    const [innerCrispyness, setInnerCrispyness] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);

    async function handleSubmit() {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify({
                'id': id,
                'product': product?.id,
                'duration': duration,
                'temperature': temperature,
                'crispyness': crispyness,
                'innerCrispyness': innerCrispyness
            })
        };
        const response = await fetch('/api/report', requestOptions);
        if(response.ok){
            navigate('/report', {state: {message: 'Der Erfahrungsbericht wurde erfolgreich bearbeitet.'}});
        }else{
            const json = await response.json();
            setErrorMessage(json.message);
        }
    };

    useEffect(() => {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'GET',
            headers: myHeaders
        };
        
        fetch('/api/public/products?searchTerm=', requestOptions)
        .then(r => r.json())
        .then(res => {
            let products = [];
            res.forEach((product) => {
                products.push({id: product?.id, label: product?.name});
            })
            setSearchedProducts(products);
        })
        .catch(err => console.error(err));

        fetch('/api/crispyness', requestOptions)
        .then(r => r.json())
        .then(res => {
            setCrispynessValues(res);
        })
        .catch(err => {
            console.error(err);
        });

        fetch('/api/report/' + id, requestOptions)
        .then(r => r.json())
        .then(report => {
            setProduct({id: report?.product?.id, label: report?.product?.name});
            setDuration(report?.duration);
            setTemperature(report?.temperature);
            setCrispyness(report?.crispyness?.name);
            setInnerCrispyness(report?.innerCrispyness?.name);
        })
        .catch(error => {
            console.error(error);
        });
    }, [id]);

    return(
        <Box sx={{flexGrow: 1, maxWidth: {xs: 'calc(100% - 26px)', md: 'auto'}}} className="centered">
            <Button sx={{marginLeft:'15px !important', marginTop: '40px !important'}} fullWidth className="custom-button-root" onClick={evt => window.location.assign('/report')}>zurück</Button>
            <h2>Erfahrungsbericht bearbeiten</h2>
            <Autocomplete
            fullWidth
                disablePortal
                options={searchedProducts}
                value={product}
                onChange={(event, newValue) => {
                    setProduct(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="Produkt" />}
            />
            <TextField fullWidth value={temperature} label="Temperatur (°C)" type="number" onChange={(event) => setTemperature(event.target.value)}/>
            <TextField fullWidth value={duration} label="Dauer (min)" type="number" onChange={(event) => setDuration(event.target.value)}/>
            <FormControl fullWidth>
                <InputLabel>Krossheits-Level</InputLabel>
                <Select
                    label="Krossheits-Level"
                    value={crispyness}
                    onChange={(event) => setCrispyness(event.target.value)}>
                        {crispynessValues?.map(cris => (
                            <MenuItem value={cris?.name} key={cris?.name}>{cris?.label}</MenuItem>)
                        )}
                </Select>
            </FormControl>
            <FormControl fullWidth>
                <InputLabel>Krossheits-Level innen</InputLabel>
                <Select
                    label="Krossheits-Level innen"
                    value={innerCrispyness}
                    onChange={(event) => setInnerCrispyness(event.target.value)}>
                        {crispynessValues?.map(cris => (
                            <MenuItem value={cris?.name} key={cris?.name}>{cris?.label}</MenuItem>)
                        )}
                </Select>
            </FormControl>
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={() => handleSubmit()}>Speichern</Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        </Box>
    );
}

export default EditReportPage;